module.exports = __webpack_public_path__ + "158352d71831815a1a877675fb66fec4.png";